import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const engagementModels = [
    {
        title: 'Dedicated AI Teams',
        description: 'Build a dedicated team of AI experts tailored to your project needs, ensuring long-term collaboration and efficiency.',
    },
    {
        title: 'Project-Based Engagement',
        description: 'Leverage AI expertise for specific projects with well-defined deliverables and timelines.',
    },
    {
        title: 'AI Consulting Services',
        description: 'Get expert advice and strategic guidance on AI implementation, optimization, and scaling.',
    },
    {
        title: 'Staff Augmentation',
        description: 'Enhance your in-house team by integrating AI specialists to accelerate development and deployment.',
    },
    {
        title: 'Custom AI Solutions',
        description: 'Develop AI-driven solutions tailored to your business challenges, from predictive analytics to automation.',
    },
    {
        title: 'Hybrid Engagement',
        description: 'Combine multiple engagement models to create a flexible AI adoption strategy that fits your needs.',
    },
    {
        title: 'AI Training & Mentorship',
        description: 'Upskill your workforce with AI training programs and mentorship from industry experts.',
    },
    {
        title: 'Managed AI Services',
        description: 'Outsource AI operations and maintenance to our expert team, ensuring seamless AI performance and innovation.',
    },
];

function FlexibleEngagementModels() {
    return (
        <Layout>
            <Content style={{ padding: '50px' }}>
                <Title level={2}>Flexible Engagement Models</Title>
                <Paragraph>
                    At JectHub, we understand that every organization has unique AI needs. That’s why we offer flexible engagement models to help businesses 
                    integrate AI seamlessly, whether through dedicated teams, consulting, or custom solutions.
                </Paragraph>
                <Row gutter={[16, 16]}>
                    {engagementModels.slice(0, 4).map((model, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={model.title} bordered={false}>
                                <Paragraph>{model.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <hr style={{ margin: '40px 0' }} />
                <Row gutter={[16, 16]}>
                    {engagementModels.slice(4, 8).map((model, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={model.title} bordered={false}>
                                <Paragraph>{model.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </Layout>
    );
}

export default FlexibleEngagementModels;
